import { render } from "./page-2.3.vue?vue&type=template&id=6ecdbf63&scoped=true"
import script from "./page-2.3.vue?vue&type=script&lang=js"
export * from "./page-2.3.vue?vue&type=script&lang=js"

import "./page-2.3.vue?vue&type=style&index=0&id=6ecdbf63&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ecdbf63"]])

export default __exports__